import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2c1f280"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-item" }
const _hoisted_2 = ["src"]

import { Uploader } from 'vant'
import { useUploadImage } from '@/compositions/useUpload'
import type { CommonUploaderFileListItem } from '@/types/public'
import { Ref, ref, withDefaults, watch, nextTick } from 'vue'
import FileSvg from '@/assets/file.svg'
import { Dialog } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFile',
  props: {
    defaultList: { default: () => [] },
    maxCount: { default: 'Infinity' },
    useCrmUpload: { type: Boolean, default: false },
    capture: null,
    acceptValue: { default: '*' }
  },
  emits: ['change', 'init'],
  setup(__props: any, { emit: emits }) {

const props = __props as { defaultList: CommonUploaderFileListItem[], maxCount: string | number, useCrmUpload: boolean, capture?: string, acceptValue: string };



const { vantUploadHandle, vantCrmUploadHandle } = useUploadImage()

const fileList: Ref<CommonUploaderFileListItem[]> = ref(props.defaultList)
function addFiles(files: File[]) {
  // 手动添加file文件
  fileList.value = fileList.value.concat(
    files.map((file) => ({
      status: '',
      file,
    }))
  )
  afterReadHandle()
}
function changeHandle() {
  emits('change', fileList.value)
}
async function afterReadHandle() {
  const list = fileList.value.filter((item) => item.status === '')
  props.useCrmUpload ? await vantCrmUploadHandle(list) : await vantUploadHandle(list)
  changeHandle()
}

function deleteHandle() {
  changeHandle()
}
emits('init', {
  addFiles,
})
watch(
  () => fileList.value,
  () => {
    nextTick(() => {
      let fileBox = document.getElementsByClassName('van-uploader__file')
      Array.from(fileBox).map((fileBoxItem) => {
        fileBoxItem.addEventListener('click', () => {
          Dialog.alert({
            title: '提示',
            message: '暂不支持手机预览文件格式',
            confirmButtonColor: 'rgba(0, 195, 120, 1)',
            confirmButtonText: '知道了',
          })
        })
        let fileName = fileBoxItem.getElementsByClassName('van-uploader__file-name')[0]
        fileName.innerHTML = '文件'
        fileBoxItem.firstElementChild.outerHTML = `<img width="37" height="47" src='${FileSvg}' style="margin-top: 10px;margin-bottom: -6px;"></img>`
      })
    })
  },
  {
    immediate: true,
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Uploader), {
        class: "custom-wrap",
        afterRead: afterReadHandle,
        modelValue: fileList.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
        multiple: "",
        "upload-icon": "plus",
        "max-count": __props.maxCount,
        onDelete: deleteHandle,
        accept: __props.acceptValue,
        capture: __props.capture
      }, null, 8, ["modelValue", "max-count", "accept", "capture"])
    ]),
    _createElementVNode("img", {
      src: _unref(FileSvg),
      style: {"display":"none"}
    }, null, 8, _hoisted_2)
  ], 64))
}
}

})